var Breakpoints = /*#__PURE__*/function (Breakpoints) {
  Breakpoints["xxl"] = "1440px";
  Breakpoints["xl"] = "1200px";
  Breakpoints["lg"] = "1024px";
  Breakpoints["ml"] = "992px";
  Breakpoints["md"] = "768px";
  Breakpoints["sm"] = "600px";
  Breakpoints["xs"] = "599px";
  return Breakpoints;
}(Breakpoints || {});
export default Breakpoints;